export default __webpack_public_path__ + "static/media/hero-level-7-chars-mob.408f55fd.webp";